import { createBrowserHistory } from "history";
import { createMemoryHistory } from "history";
import { isServer } from "utils/env";

function createHistoryForCurrentEnvironment() {
  if (isServer()) {
    return createMemoryHistory();
  }
  return createBrowserHistory();
}
export default createHistoryForCurrentEnvironment();
